<h1 mat-dialog-title>Donations, thanks :)</h1>
<div mat-dialog-content>
  <div style="text-align: center">
    <img alt="bc1q6gafwx8ca0d7kj3s3kmkkcduycay4v9qpqz2kd" title="bc1q6gafwx8ca0d7kj3s3kmkkcduycay4v9qpqz2kd" height="150" src='assets/btc-qrcode.png'>
    <b>bc1q6gafwx8ca0d7kj3s3kmkkcduycay4v9qpqz2kd</b>
  </div>
</div>

